import {
  Inject,
  Injectable,
  signal,
  WritableSignal,
  DOCUMENT,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TMediaType } from '@src/app/shared/types/common';
import { RoutesEnum } from '@src/app/enums';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private bodyColor: WritableSignal<string> = signal('');
  private isMediaMode: WritableSignal<boolean> = signal(false);
  private isHomepage: WritableSignal<boolean> = signal(false);
  private isHeaderFixed: WritableSignal<boolean> = signal(true);
  private isHeaderVisible: WritableSignal<boolean> = signal(true);
  private isFooterVisible: WritableSignal<boolean> = signal(true);
  private hasOrderButtonPined: WritableSignal<boolean> = signal(false);

  private mediaTypeSubject = new BehaviorSubject<TMediaType>(RoutesEnum.NEWS);
  mediaType$ = this.mediaTypeSubject.asObservable();

  constructor(@Inject(DOCUMENT) private document: Document) {}

  getBodyColor(): string {
    return this.bodyColor();
  }

  getIsMediaMode(): boolean {
    return this.isMediaMode();
  }

  getIsHomepage(): boolean {
    return this.isHomepage();
  }

  getIsHeaderFixed(): boolean {
    return this.isHeaderFixed();
  }

  getIsHeaderVisible(): boolean {
    return this.isHeaderVisible();
  }

  getIsFooterVisible(): boolean {
    return this.isFooterVisible();
  }

  getHasOrderButtonPined(): boolean {
    return this.hasOrderButtonPined();
  }

  get mediaType(): TMediaType {
    return this.mediaTypeSubject.value;
  }

  setBodyColor(color: string): void {
    this.bodyColor.set(color);
    this.document.body.style.backgroundColor = color;
  }

  setMediaType(type: TMediaType): void {
    this.mediaTypeSubject.next(type);
  }

  setIsMediaMode(value: boolean): void {
    this.isMediaMode.set(value);
  }

  setIsHeaderFixed(value: boolean): void {
    this.isHeaderFixed.set(value);
  }

  setIsHeaderVisible(value: boolean): void {
    this.isHeaderVisible.set(value);
  }

  setIsFooterVisible(value: boolean): void {
    this.isFooterVisible.set(value);
  }

  setIsHomepage(value: boolean): void {
    this.isHomepage.set(value);
  }

  setHasOrderButtonPined(value: boolean): void {
    this.hasOrderButtonPined.set(value);
  }
}
